import { struct } from 'io-ts/Decoder';

import { Id as UserId } from '../../../../user/Id';

export const Param = struct({
	userId: UserId,
});
